<sync-header-shares-accept></sync-header-shares-accept>
<router-outlet></router-outlet>
<sync-footer></sync-footer>